import "core-js/modules/es.array.find-index";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, tool, commonData } from "@/mixins/index";
import addLoginType from "./components/addLoginType";
import loginFnDetail from "./components/loginFnDetail.vue";
export default {
  name: "loginUserList",
  mixins: [loadMoreList, tool, commonData],
  components: {
    addLoginType: addLoginType,
    loginFnDetail: loginFnDetail
  },
  data: function data() {
    return {
      pagingReqFn: "LoginDatauserData",
      paramsData: {
        isMustAppid: 2
      },
      userStatus: [{
        label: '正常',
        value: 1
      }, {
        label: '封禁',
        value: 3
      }],
      dateType: 'arr'
    };
  },
  created: function created() {
    this.getTodayRange(this.dateType);
    this.getList();
    this.getcommonData(['appListAllData']);
  },
  activated: function activated() {},
  methods: {
    t: function t() {
      this.getList(); // setTimeout(()=>{
      //   this.tableData[0].status = 2
      //   console.log(this.tableData[0].status)
      // },2000)
    },
    goToDetail: function goToDetail(row, type) {
      this.$refs.loginFnDetail.init(row, type, 'login');
    },
    goToRealDetail: function goToRealDetail(row) {
      if (row.is_realname != true) {
        return;
      }

      this.$refs.loginFnDetail.init(row, 6, 'isReal');
    },
    statusChange: function statusChange(e, row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var status;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(e.target.tagName === "INPUT")) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                status = 1;

                if (row.status == 1) {
                  status = 3;
                } else if (row.status == 3) {
                  status = 1;
                } else if (row.status == 2) {
                  status = 1;
                }

                _this.$confirm('请确认当前操作?', '确认', {
                  confirmButtonText: '确认',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  _this.$api.loginUserBan({
                    id: row.id,
                    status: status,
                    table_name: row.table_name
                  }).then(function (res) {
                    if (res.status == 200) {
                      var index = _this.tableData.findIndex(function (i) {
                        return i.id == row.id;
                      });

                      _this.tableData[index].status = status;

                      _this.$message.success('修改成功');
                    }
                  });
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};